import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import MembersListBlockData from 'app/Models/Content/MembersListBlockData';
import React from 'react';
import TagName from 'app/Components/Shared/TagName';
import {Container} from 'reactstrap';

const MembersListBlock = (props: ComponentProps<MembersListBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props}>
      <div className='MembersListBlock'>
        <TagName className='MembersListBlock__title' tagName={data.titleHeadlineTag?.value}>
          חברי הנהלה
        </TagName>
        <Container className='MembersListBlock__wrapper'>
          <ContentArea context={context} data={data.items} noWrap />
        </Container>
      </div>
    </BlockWrapper>
  );
};

export default MembersListBlock;
